function trimUrl(url: string) {
  return url.replace(/[),.;!?]+$/u, '')
}

function isPdfUrl(url: string) {
  try {
    return new URL(url).pathname.toLowerCase().endsWith('.pdf')
  } catch {
    return false
  }
}

export function getPdfUrl(text: string) {
  const urls = text.match(/https?:\/\/[^\s<>"']+/giu) || []

  return urls.map(trimUrl).find(isPdfUrl) || ''
}
